module.exports = __webpack_public_path__ + "img/tabach_no.4e3e23da.png";